import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import './Tiendas.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleDoubleRight,
    faStore,
    faBed,
    faUtensils,
    faCompass,
    faHeart,
    faCut,
    faWrench,
    faMusic,
    faGift,
    faDumbbell,
    faShoppingBag,
    faLaptop,
    faGem,
    faCamera,
    faPalette,
    faClock
} from '@fortawesome/free-solid-svg-icons';
import 'react-toastify/dist/ReactToastify.css';
import LoadingTiendas from '../LoadingTiendas/LoadingTiendas';
import { Link as Anchor } from "react-router-dom";
import ProductsHome from '../ProductsHome/ProductsHome';
import { calcularEstadoHorario } from '../../utils/horarioHelper';

SwiperCore.use([Navigation, Pagination, Autoplay]);

// Paleta de estilos y recursos visuales para cada tipo de categoría
const getCategoryMeta = (name, index) => {
    const text = (name || '').toLowerCase();

    const themes = [
        {
            color: '#2563eb',
            gradient: 'linear-gradient(to top, rgba(29, 78, 216, 0.95) 0%, rgba(29, 78, 216, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faBed,
            defaultImg: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=500&auto=format&fit=crop&q=60',
            suffix: 'Alojamientos'
        },
        {
            color: '#ea580c',
            gradient: 'linear-gradient(to top, rgba(234, 88, 12, 0.95) 0%, rgba(234, 88, 12, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faUtensils,
            defaultImg: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=500&auto=format&fit=crop&q=60',
            suffix: 'Locales'
        },
        {
            color: '#0d9488',
            gradient: 'linear-gradient(to top, rgba(13, 148, 136, 0.95) 0%, rgba(13, 148, 136, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faCompass,
            defaultImg: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=500&auto=format&fit=crop&q=60',
            suffix: 'Aventuras'
        },
        {
            color: '#e11d48',
            gradient: 'linear-gradient(to top, rgba(225, 29, 72, 0.95) 0%, rgba(225, 29, 72, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faHeart,
            defaultImg: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=500&auto=format&fit=crop&q=60',
            suffix: 'Clínicas & Salud'
        },
        {
            color: '#9333ea',
            gradient: 'linear-gradient(to top, rgba(147, 51, 234, 0.95) 0%, rgba(147, 51, 234, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faMusic,
            defaultImg: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=500&auto=format&fit=crop&q=60',
            suffix: 'Lugares y diversión'
        },
        {
            color: '#db2777',
            gradient: 'linear-gradient(to top, rgba(219, 39, 119, 0.95) 0%, rgba(219, 39, 119, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faCut,
            defaultImg: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=500&auto=format&fit=crop&q=60',
            suffix: 'Salones'
        },
        {
            color: '#475569',
            gradient: 'linear-gradient(to top, rgba(71, 85, 105, 0.95) 0%, rgba(71, 85, 105, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faWrench,
            defaultImg: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=500&auto=format&fit=crop&q=60',
            suffix: 'Servicios'
        }
    ];

    if (text.includes('hotel') || text.includes('alojamiento') || text.includes('hospedaje')) {
        return { ...themes[0], icon: faBed, suffix: 'Alojamientos' };
    }
    if (text.includes('restauran') || text.includes('comida') || text.includes('postre') || text.includes('gastronom')) {
        return { ...themes[1], icon: faUtensils, suffix: 'Locales' };
    }
    if (text.includes('viaje') || text.includes('tour') || text.includes('turismo') || text.includes('aventura')) {
        return { ...themes[2], icon: faCompass, suffix: 'Aventuras' };
    }
    if (text.includes('salud') || text.includes('botic') || text.includes('farmacia') || text.includes('medic') || text.includes('veterinaria')) {
        return { ...themes[3], icon: faHeart, suffix: 'Clínicas & Boticas' };
    }
    if (text.includes('entretenimiento') || text.includes('mariachi') || text.includes('musica') || text.includes('show') || text.includes('diversion')) {
        return { ...themes[4], icon: faMusic, suffix: 'Lugares & Show' };
    }
    if (text.includes('belleza') || text.includes('perfume')) {
        return { ...themes[5], icon: faCut, suffix: 'Salones' };
    }
    if (text.includes('ropa') || text.includes('zapato') || text.includes('moda')) {
        return {
            color: '#0891b2',
            gradient: 'linear-gradient(to top, rgba(8, 145, 178, 0.95) 0%, rgba(8, 145, 178, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faShoppingBag,
            defaultImg: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=500&auto=format&fit=crop&q=60',
            suffix: 'Tiendas de Moda'
        };
    }
    if (text.includes('bisuter') || text.includes('joya')) {
        return {
            color: '#d97706',
            gradient: 'linear-gradient(to top, rgba(217, 119, 6, 0.95) 0%, rgba(217, 119, 6, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faGem,
            defaultImg: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500&auto=format&fit=crop&q=60',
            suffix: 'Joyerías'
        };
    }
    if (text.includes('gym') || text.includes('deporte') || text.includes('fitness')) {
        return {
            color: '#0284c7',
            gradient: 'linear-gradient(to top, rgba(2, 132, 199, 0.95) 0%, rgba(2, 132, 199, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faDumbbell,
            defaultImg: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=500&auto=format&fit=crop&q=60',
            suffix: 'Gimnasios'
        };
    }
    if (text.includes('regalo') || text.includes('juguete') || text.includes('artesan')) {
        return {
            color: '#f59e0b',
            gradient: 'linear-gradient(to top, rgba(245, 158, 11, 0.95) 0%, rgba(245, 158, 11, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faGift,
            defaultImg: 'https://images.unsplash.com/photo-1513885535751-8b9238bd345a?w=500&auto=format&fit=crop&q=60',
            suffix: 'Regalerías'
        };
    }
    if (text.includes('tecnolog') || text.includes('soporte') || text.includes('importacion')) {
        return {
            color: '#4f46e5',
            gradient: 'linear-gradient(to top, rgba(79, 70, 229, 0.95) 0%, rgba(79, 70, 229, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faLaptop,
            defaultImg: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=500&auto=format&fit=crop&q=60',
            suffix: 'Tecnología'
        };
    }
    if (text.includes('produccion') || text.includes('audio') || text.includes('foto')) {
        return {
            color: '#059669',
            gradient: 'linear-gradient(to top, rgba(5, 150, 105, 0.95) 0%, rgba(5, 150, 105, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faCamera,
            defaultImg: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=500&auto=format&fit=crop&q=60',
            suffix: 'Audiovisual'
        };
    }
    if (text.includes('decoracion')) {
        return {
            color: '#8b5cf6',
            gradient: 'linear-gradient(to top, rgba(139, 92, 246, 0.95) 0%, rgba(139, 92, 246, 0.55) 50%, rgba(0,0,0,0.05) 100%)',
            icon: faPalette,
            defaultImg: 'https://images.unsplash.com/photo-1513519245088-0e12902e5a38?w=500&auto=format&fit=crop&q=60',
            suffix: 'Decoración'
        };
    }

    return themes[index % themes.length];
};

export default function Tiendas() {
    const [loading, setLoading] = useState(true);
    const [tiendas, setTiendas] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);

    const shuffleArray = (array) => {
        const arr = [...array];
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    };

    const cargarTiendas = async () => {
        let tiendasData = [];
        try {
            const response = await fetch(`${baseURL}/tiendasFrontend.php`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            if (Array.isArray(data?.tiendas) && data.tiendas.length > 0) {
                tiendasData = data.tiendas;
            }
        } catch (error) {
            console.warn('tiendasFrontend.php falló en Tiendas, usando tiendaGet.php...', error);
        }

        if (tiendasData.length === 0) {
            try {
                const fallbackRes = await fetch(`${baseURL}/tiendaGet.php`, {
                    method: 'GET',
                    credentials: 'include'
                });
                const fallbackData = await fallbackRes.json();
                if (Array.isArray(fallbackData?.tiendas)) {
                    tiendasData = fallbackData.tiendas.filter(t => !t.estado || t.estado === 'visible');
                }
            } catch (errFallback) {
                console.error('Error en fallback tiendaGet.php:', errFallback);
            }
        }

        const tiendasAleatorias = shuffleArray(tiendasData);
        setTiendas(tiendasAleatorias);
        setLoading(false);
        cargarCategoria(tiendasAleatorias);
    };

    const cargarCategoria = (tiendasList = []) => {
        fetch(`${baseURL}/categoriaTiendaGet.php`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                const cats = data.categorias || [];
                if (cats.length > 0) {
                    setCategorias(cats);

                    setCategoriaSeleccionada(prev => {
                        if (prev) return prev;
                        // Priorizar una categoría que tenga tiendas registradas
                        const catConTiendas = cats.find(c =>
                            Number(c.cantidad_tiendas) > 0 ||
                            tiendasList.some(t => Number(t.idCategoria) === Number(c.idCategoria))
                        );
                        return catConTiendas ? Number(catConTiendas.idCategoria) : Number(cats[0].idCategoria);
                    });
                }
            })
            .catch(error => {
                console.error('Error al cargar categorías:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        cargarTiendas();

        // Escuchar selección de categoría desde el menú superior
        const handleFilterCategory = (e) => {
            if (e.detail) {
                setCategoriaSeleccionada(Number(e.detail));
                const element = document.getElementById('TiendaContain');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        window.addEventListener('filter-tienda-categoria', handleFilterCategory);

        // Revisar si viene categoría por parámetro URL
        const params = new URLSearchParams(window.location.search);
        const catFromUrl = params.get('catTienda');
        if (catFromUrl) {
            setCategoriaSeleccionada(Number(catFromUrl));
            setTimeout(() => {
                const element = document.getElementById('TiendaContain');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
            }, 300);
        }

        return () => window.removeEventListener('filter-tienda-categoria', handleFilterCategory);
    }, []);

    const handleClickCategoria = (idCat) => {
        setCategoriaSeleccionada(Number(idCat));
    };

    // Contar tiendas por categoría
    const getTiendasCount = (idCategoria, categoriaObj) => {
        if (categoriaObj && categoriaObj.cantidad_tiendas !== undefined) {
            return Number(categoriaObj.cantidad_tiendas);
        }
        return tiendas.filter(t => Number(t.idCategoria) === Number(idCategoria)).length;
    };

    const tiendasFiltradas = tiendas.filter(item => Number(item.idCategoria) === Number(categoriaSeleccionada));
    const categoriaActual = categorias.find(c => Number(c.idCategoria) === Number(categoriaSeleccionada));

    return (
        <div className='TiendaContain' id='TiendaContain'>

            {/* CARRUSEL DE CATEGORÍAS ESTILO PREMIUM ALEATORIO */}
            {categorias.length > 0 && (
                <div className='categoryCardsSection'>
                    <Swiper
                        spaceBetween={14}
                        freeMode={true}
                        grabCursor={true}
                        preventClicks={false}
                        preventClicksPropagation={false}
                        touchStartPreventDefault={false}
                        observer={true}
                        observeParents={true}
                        className='categorySwiper'
                        breakpoints={{
                            320: { slidesPerView: 2.3, spaceBetween: 10 },
                            480: { slidesPerView: 3.2, spaceBetween: 12 },
                            640: { slidesPerView: 4.2, spaceBetween: 12 },
                            768: { slidesPerView: 5.2, spaceBetween: 14 },
                            1024: { slidesPerView: 6, spaceBetween: 14 },
                            1280: { slidesPerView: 7, spaceBetween: 16 }
                        }}
                    >
                        {categorias.map((item, index) => {
                            const meta = getCategoryMeta(item.categoria, index);
                            const count = getTiendasCount(item.idCategoria, item);
                            const imgSource = item.imagen ? item.imagen : meta.defaultImg;
                            const isSelected = Number(categoriaSeleccionada) === Number(item.idCategoria);
                            const rubroColor = item.color || meta.color;
                            const rubroGradient = item.color
                                ? `linear-gradient(to top, ${item.color}ee 0%, ${item.color}88 50%, rgba(0,0,0,0.05) 100%)`
                                : meta.gradient;

                            return (
                                <SwiperSlide
                                    className='categorySwiperSlide'
                                    key={item.idCategoria}
                                    onClick={() => handleClickCategoria(item.idCategoria)}
                                >
                                    <div
                                        className={`categoryCard ${isSelected ? 'active' : ''}`}
                                        onClick={() => handleClickCategoria(item.idCategoria)}
                                        style={isSelected ? {
                                            borderColor: rubroColor,
                                            boxShadow: `0 14px 28px -6px ${rubroColor}66, 0 0 0 2.5px ${rubroColor}`
                                        } : {}}
                                    >
                                        <img
                                            src={imgSource}
                                            alt={item.categoria}
                                            className="categoryCardImg"
                                            onError={(e) => { e.target.src = meta.defaultImg; }}
                                        />
                                        <div
                                            className="categoryCardOverlay"
                                            style={{ background: rubroGradient }}
                                        />
                                        <div className="categoryCardContent">
                                            <div className="categoryCardIcon" style={{ backgroundColor: rubroColor }}>
                                                <FontAwesomeIcon icon={meta.icon} />
                                            </div>
                                            <span className="categoryCardTitle">{item.categoria}</span>
                                            <span
                                                className="categoryCardPill"
                                                style={item.color ? {
                                                    borderColor: `${rubroColor}99`,
                                                    backgroundColor: `${rubroColor}33`,
                                                    color: '#ffffff',
                                                    fontWeight: 700,
                                                    backdropFilter: 'blur(4px)'
                                                } : {}}
                                            >
                                                {count > 0 ? `${count} ${count === 1 ? 'Local' : 'Locales'}` : `${meta.suffix}`}
                                            </span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            )}

            {/* SECCIÓN DE TIENDAS FILTRADAS POR LA CATEGORÍA SELECCIONADA */}
            {loading ? (
                <LoadingTiendas />
            ) : (
                <div style={{ marginTop: '1.5rem', minHeight: '220px' }}>
                    {categoriaActual && (
                        <div className="categoriaTiendasHeader">
                            <div className="categoriaTiendasHeaderTitle">
                                <FontAwesomeIcon
                                    icon={faStore}
                                    className="categoriaHeaderIcon"
                                    style={{ color: categoriaActual.color || 'var(--color1, #ff5722)' }}
                                />
                                <h3>
                                    Tiendas en <span style={{ color: categoriaActual.color || 'var(--color1, #ff5722)' }}>{categoriaActual.categoria}</span>
                                </h3>
                            </div>
                            <span
                                className="categoriaHeaderCount"
                                style={categoriaActual.color ? {
                                    color: categoriaActual.color,
                                    backgroundColor: `${categoriaActual.color}15`,
                                    borderColor: `${categoriaActual.color}40`,
                                    borderWidth: '1px',
                                    borderStyle: 'solid'
                                } : {}}
                            >
                                {tiendasFiltradas.length} {tiendasFiltradas.length === 1 ? 'tienda disponible' : 'tiendas disponibles'}
                            </span>
                        </div>
                    )}

                    {tiendasFiltradas.length > 0 ? (
                        <div className="tiendasGrid">
                            {tiendasFiltradas.map(item => {
                                const estadoHorario = calcularEstadoHorario(item.horario);

                                return (
                                    <Anchor
                                        className='cardTienda'
                                        to={`/tienda/${item.idTienda}/${item.nombre.replace(/\s+/g, '-')}`}
                                        key={item.idTienda}
                                    >
                                        <div className="imgTiendaBannerWrapper">
                                            <img
                                                src={item.imagen2}
                                                alt={item.nombre}
                                                className='imgTiendaBanner'
                                                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=500&auto=format&fit=crop&q=60'; }}
                                            />
                                            <span className="categoriaBadgeTienda">
                                                {categoriaActual?.categoria || 'Tienda'}
                                            </span>

                                            {/* BADGE DINÁMICO ABIERTO / CERRADO */}
                                            <span className={`badgeHorarioTienda ${estadoHorario.abierto ? 'abierto' : 'cerrado'}`}>
                                                {estadoHorario.abierto ? (
                                                    <>
                                                        <span className="puntoEnVivo"></span>
                                                        <span>Abierto</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="puntoCerrado"></span>
                                                        <span>Cerrado</span>
                                                    </>
                                                )}
                                            </span>
                                        </div>
                                        <div className='cardTextTienda'>
                                            <img
                                                src={item.imagen1}
                                                alt={item.nombre}
                                                className='CardlogoTienda'
                                                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60'; }}
                                            />
                                            <div className="cardTextInfo">
                                                <h4>{item.nombre}</h4>
                                                <h5>{item.direccion}</h5>
                                                {item.horario && (
                                                    <div className="cardHorarioInfo" title={estadoHorario.resumen}>
                                                        <FontAwesomeIcon icon={faClock} className={`iconClock ${estadoHorario.abierto ? 'clockAbierto' : 'clockCerrado'}`} />
                                                        <span>{estadoHorario.detalle}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                        </div>
                                    </Anchor>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="noTiendasContainer">
                            <FontAwesomeIcon icon={faStore} className="noTiendasIcon" />
                            <p className="noTiendasTitle">
                                Aún no hay local registradas en la categoría <strong>"{categoriaActual?.categoria || ''}"</strong>.
                            </p>
                            <p className="noTiendasSubtitle">
                                Selecciona otra categoría en las tarjetas superiores para explorar tiendas disponibles.
                            </p>
                        </div>
                    )}
                </div>
            )}
            <ProductsHome />
        </div>
    );
}
